module.exports = Object.freeze({
    /**Also known as RedBeam */
    ASSET_TRACKING: '100000000000100000000077',
    /** also known as RIT */
    INVENTORY_TRACKING: '675b31ba52bc204f550b79c8',
    /** temporary entry until we have dropped the "REDBEAM" part */
    REDBEAM_RFID: '67d0317e09942df7e3753f16',
    RFID: '67d0317e09942df7e3753f16',

    // "OLD" Strategic RFID apps:
    ITEM_TRACKING: '100000000000100000000001',
    WORK_IN_PROCESS: '64ff73f08a86850bcaa3aba9',

    /** Simplified version of AT for use with 3rd Party Flair system */
    FLAIR: '10000000000010464c414952',
    PALM: '100000000000100050414c4d',

    //Internal apps:
    META_DATA_CREATOR: '603ec9c15a49667064a222dc',
    NUCLEUS: '100000000000100000000004',
    ONE_TOUCH: '100000000000100000000008',

    // Custom Apps:
    /** Duke specific Add-on for Item Tracking  */
    WISE_ID: '606cc09f23cb94dc2dceb5d7',
    /** CAPSTONE CUSTOM APP */
    FREIGHT_RUNNER: '65e8ef647334e2d8f4502408',
    RB_DIRECTSCAN: '69fa0f5316737f035ca30b51'
});
